import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/__authed/m/stock/")({
	beforeLoad: () => {
		throw redirect({ to: "/m/stock/material-groups" });
	},
});
